// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".write-off-table .text-red[data-v-156a7b62] {\n  color: #f56c6c !important;\n}\n", ""]);
// Exports
module.exports = exports;
